"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "buseto-palizzolo": {
    "de882128": [{
      "hkey": "9a1424d5",
      "slug": "centro-badia-battaglia",
      "name": "Centro-Badia-Battaglia",
      "primary": true,
      "skipSearch": false
    }],
    "badia": [{
      "hkey": "9a1424d5",
      "slug": "centro-badia-battaglia",
      "name": "Centro-Badia-Battaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "buseto-palizzolo"
    }],
    "a9f191ef": [{
      "hkey": "9a1424d5",
      "slug": "centro-badia-battaglia",
      "name": "Centro-Badia-Battaglia",
      "primary": true,
      "skipSearch": false
    }],
    "battaglia": [{
      "hkey": "9a1424d5",
      "slug": "centro-badia-battaglia",
      "name": "Centro-Badia-Battaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "buseto-palizzolo"
    }],
    "d8d54cf2": [{
      "hkey": "9a1424d5",
      "slug": "centro-badia-battaglia",
      "name": "Centro-Badia-Battaglia",
      "primary": true,
      "skipSearch": false
    }],
    "buseto-centro": [{
      "hkey": "9a1424d5",
      "slug": "centro-badia-battaglia",
      "name": "Centro-Badia-Battaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0f497f71": [{
      "hkey": "aebd0d4f",
      "slug": "buseto-superiore",
      "name": "Buseto Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "buseto-soprano": [{
      "hkey": "aebd0d4f",
      "slug": "buseto-superiore",
      "name": "Buseto Superiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "65c41460": [{
      "hkey": "3b215eff",
      "slug": "luziano",
      "name": "Luziano",
      "primary": true,
      "skipSearch": false
    }],
    "pianoneve-luziano": [{
      "hkey": "3b215eff",
      "slug": "luziano",
      "name": "Luziano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d8d6dffe": [{
      "hkey": "c451eb5f",
      "slug": "buseto-palizzolo",
      "name": "Buseto Palizzolo",
      "primary": true,
      "skipSearch": false
    }],
    "tangi-blindano": [{
      "hkey": "c451eb5f",
      "slug": "buseto-palizzolo",
      "name": "Buseto Palizzolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;